import vendorsConfig from "../vendorsConfig";
export const handleGoogleReview = (storeInfo,invoiceDetail) => {
    if(storeInfo.ratings.includes("google")){
        let url = `https://search.google.com/local/writereview?placeid=${storeInfo.rating_id}`  
        window.open(url, '_self');
    }
}

export const handleGoogleReviewOnload = (storeInfo,invoiceDetail) => {
    if((!storeInfo.ratings.includes(vendorsConfig.SLUG)) || invoiceDetail.isReviewed === true && storeInfo.ratings.includes("google")){
        setTimeout(() => {
            let url = `https://search.google.com/local/writereview?placeid=${storeInfo.rating_id}`  
            window.open(url, '_self');
        }, 3000);
    }
}
